import { Component, Input } from '@angular/core';
import { CsIconModule } from '@components/icon';
import { HeroIngredient, MorningNightProduct, Regimen } from '@cureskin/api-client/src/server-api';
import { NgClass } from "@angular/common";

interface ExperimentMaps {
  FACEWASH_MAP?: Record<string, Record<string, string>>;
  SUPPLEMENT_MAP?: Record<string, Record<string, string>>;
}

const NUTRA_FACE_MASK_PRODUCTS = ['MYfqI3YkfS', 'fBTFPnICk2'];
const SEBUM_PRODUCT = 'OnnVCpJ4lN';

@Component({
  selector: 'app-report-treatment-plan',
  imports: [
    CsIconModule,
    NgClass
  ],
  templateUrl: './report-treatment-plan.component.html',
})

export class ReportTreatmentPlanComponent {
  @Input() allocatedDoctorImage: string;
  @Input() displayConcern: string;
  @Input() languagePreference: string;
  @Input() showArrowUI: boolean;
  @Input() regimen: Regimen & { displayConcern?: { name?: string } };
  @Input() experiment: ExperimentMaps;

  private get allProducts(): MorningNightProduct[] {
    return [...(this.regimen?.morning || []), ...(this.regimen?.night || [])];
  }

  private get facewashProductId(): string | undefined {
    const facewashMap = this.experiment?.FACEWASH_MAP || {};
    return this.allProducts
      .find(item => item?.product?.objectId in facewashMap)
      ?.product?.objectId;
  }

  private get supplementProductId(): string | undefined {
    const supplementMap = this.experiment?.SUPPLEMENT_MAP || {};
    return this.allProducts
      .find(item => item?.product?.objectId in supplementMap)
      ?.product?.objectId;
  }

  get showFaceMaskHeader(): boolean {
    const id = this.supplementProductId;
    return !!id && NUTRA_FACE_MASK_PRODUCTS.includes(id);
  }

  get showSebumHeader(): boolean {
    const id = this.supplementProductId;
    return !!id && SEBUM_PRODUCT === id;
  }

  get repairIngredients(): HeroIngredient[] {
    const repairIngredients = this.allProducts.filter(item => item?.product?.isRepair)
      .flatMap(item => (item.product?.heroIngredients as unknown as HeroIngredient[]) || []);

    if (!repairIngredients.length) {
      const heroIngredientsProducts = [...this.allProducts]?.reverse()
        .find(item => (item?.product?.heroIngredients as unknown as HeroIngredient[])?.length);
      if (!heroIngredientsProducts) return [];
      return heroIngredientsProducts.product.heroIngredients as unknown as HeroIngredient[];
    }

    return repairIngredients.filter((ing, i, arr) => arr.findIndex(
      x => x?.objectId === ing?.objectId) === i
    );
  }

  get facewashSentence(): string {
    const facewashMap = this.experiment?.FACEWASH_MAP || {};
    return facewashMap[this.facewashProductId]?.[this.languagePreference] ?? '';
  }

  get supplementDescription(): string {
    const supplementMap = this.experiment?.SUPPLEMENT_MAP || {};
    return supplementMap[this.supplementProductId]?.[this.languagePreference] ?? '';
  }
}
